import { Injectable } from '@angular/core';
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';

import { AuthService } from '../service/auth.service';
import { HelpersService } from '@shared/services/helpers.service';
import Swal from 'sweetalert2';
import { User } from '@core/models/user';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private authService: AuthService,
    private router: Router,
    private helperService: HelpersService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
  const currentUserJson = localStorage.getItem('currentUser');
  const currentUser: User = currentUserJson ? JSON.parse(currentUserJson) : null;
    console.log(currentUser,'current user');
    
    if (currentUser) {
      const userRole = currentUser.role;
 
     if (route.data['role'] && Array.isArray(route.data['role']) && !this.helperService.isAdmin(userRole)) {
        console.log(userRole,'users');

        const isExits = route.data['role'].filter(x => userRole.includes(x));
        console.log(isExits,'it exists');

        if (isExits.length==0) {
          this.router.navigate(['/authentication/signin']);
          Swal.fire({
            title: 'You do not have access to this page',
            icon: 'warning',
            confirmButtonColor: '#e0272a',
            confirmButtonText: 'Okay',
          });
          return false;
        }
      }
      return true;
    }else{
      
    this.router.navigate(['/authentication/signin']);
    }
    this.router.navigate(['/authentication/signin']);

    return false;
  }
}
